import { render, staticRenderFns } from "./PrinterLimitsCard.vue?vue&type=template&id=256f7006&"
import script from "./PrinterLimitsCard.vue?vue&type=script&lang=ts&"
export * from "./PrinterLimitsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports